export const HomeItems = [
  {
    id: 1,
    title: 'Woman with Face Paint',
    type: 'Portrait',
    text: 'This story happened a long time ago in a galaxy far, far away. It is already over. Nothing can be done to change it. It is a story of love and loss, brotherhood and betrayal, courage and sacrifice and the death of dreams.',
    imgSrc:
      'https://images.unsplash.com/photo-1580664908941-95269d08812b?ixlib=rb-4.0.3&ixid=MnwxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8&auto=format&fit=crop&w=1887&q=80',
  },
  {
    id: 2,
    title: 'Palm Trees',
    type: 'Nature',
    text: 'It is a story of the blurred line between our best and our worst. It is the story of the end of an age. A strange thing about stories—though this all happened so long ago and so far away that words cannot describe the time or the distance, it is also happening right now.',
    imgSrc:
      'https://images.unsplash.com/photo-1518965539400-77d851d65c43?ixlib=rb-4.0.3&ixid=MnwxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8&auto=format&fit=crop&w=687&q=80',
  },
  {
    id: 3,
    title: 'Dark Pathway',
    type: 'Art',
    text: 'It is a period of civil war. Rebel spaceships, striking from a hidden base, have won their first victory against the evil Galactic Empire. During the battle, Rebel spies managed to steal secret plans to the Empires ultimate weapon, the DEATH STAR, and space station with enough power to destroy an entire planet.',
    imgSrc:
      'https://images.unsplash.com/photo-1511406361295-0a1ff814c0ce?ixlib=rb-4.0.3&ixid=MnwxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8&auto=format&fit=crop&w=687&q=80',
  },
  {
    id: 4,
    title: 'Solar Eclipse',
    type: 'Experimental',
    text: 'It is a dark time for the Rebellion. Although the Death Star has been destroyed, Imperial troops have driven the Rebel forces from their hidden base and pursued them across the galaxy.',
    imgSrc:
      'https://images.unsplash.com/photo-1509978778156-518eea30166b?ixlib=rb-4.0.3&ixid=MnwxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8&auto=format&fit=crop&w=415&q=80',
  },
  {
    id: 5,
    title: 'Burning White Dandelion',
    type: 'Wildlife',
    text: 'Turmoil has engulfed the Galactic Republic. The taxation of trade routes to outlying star systems is in dispute. Hoping to resolve the matter with a blockade of deadly battleships, the greedy Trade Federation has stopped all shipping to the small planet of Naboo.',
    imgSrc:
      'https://images.unsplash.com/photo-1492112007959-c35ae067c37b?ixlib=rb-4.0.3&ixid=MnwxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8&auto=format&fit=crop&w=684&q=80',
  },
  {
    id: 6,
    title: 'Assorted-Title Book Lot on Shelf',
    type: 'Architectural',
    text: 'There is unrest in the Galactic Senate. Several thousand solar systems have declared their intentions to leave the Republic. This separatist movement, under the leadership of the mysterious Count Dooku, has made it difficult for the limited number of Jedi Knights to maintain peace and order in the galaxy.',
    imgSrc:
      'https://images.unsplash.com/photo-1535905496755-26ae35d0ae54?ixlib=rb-4.0.3&ixid=MnwxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8&auto=format&fit=crop&w=687&q=80',
  },
  {
    id: 7,
    title: 'Man with Red and Black Paint',
    type: 'Portrait',
    text: 'War! The Republic is crumbling under attacks by the ruthless Sith Lord, Count Dooku. There are heroes on both sides. Evil is everywhere. In a stunning move, the fiendish droid leader, General Grievous, has swept into the Republic capital and kidnapped Chancellor Palpatine, leader of the Galactic Senate.',
    imgSrc:
      'https://images.unsplash.com/photo-1542974350-76c14ffc1646?ixlib=rb-4.0.3&ixid=MnwxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8&auto=format&fit=crop&w=1886&q=80',
  },
  {
    id: 8,
    title: 'Window in Darkness',
    type: 'Reality',
    text: 'Luke Skywalker has vanished. In his absence, the sinister FIRST ORDER has risen from the ashes of the Empire and will not rest until Skywalker, the last Jedi, has been destroyed.',
    imgSrc:
      'https://images.unsplash.com/photo-1516575355332-d2934104e253?ixlib=rb-4.0.3&ixid=MnwxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8&auto=format&fit=crop&w=687&q=80',
  },
  {
    id: 9,
    title: 'Chair Beside Statue',
    type: 'Art',
    text: 'The First Order reigns. Having decimated the peaceful Republic, Supreme Leader Snoke now deploys his merciless legions to seize military control of the galaxy.',
    imgSrc:
      'https://images.unsplash.com/photo-1577892210326-4b00a7a9cb47?ixlib=rb-4.0.3&ixid=MnwxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8&auto=format&fit=crop&w=1887&q=80',
  },
  {
    id: 10,
    title: 'Person Holding Torch',
    type: 'Experimental',
    text: 'The dead speak! The galaxy has heard a mysterious broadcast, a threat of REVENGE in the sinister voice of the late EMPEROR PALPATINE.',
    imgSrc:
      'https://images.unsplash.com/photo-1519074069444-1ba4fff66d16?ixlib=rb-4.0.3&ixid=MnwxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8&auto=format&fit=crop&w=1887&q=80',
  },
];
